import useSWR from 'swr';
import { authCall } from '.';
import { properties, propertyOwner, propertyTenants, propertyApproval } from './endpoints';
import { CustomPaginationQuery, IPropertyList, PropertyApprovalPayload, PropertyApprovalResponse } from '../interfaces/landlord';
// import { usePanGesture } from '@chakra-ui/react';
// import { dummyPropertyData } from '../constants/mockdata';

const PropertyService = {
  useGetPropertyList: ({
    page = 1,
    size = 15,
    name = '',
  }: CustomPaginationQuery & { name?: string }) => {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(size),
    })

    const normalizedName = name.trim()
    if (normalizedName) {
      params.append('name', normalizedName)
    }

    const url = `${properties}?${params.toString()}`
    return useSWR(url, async () => {
      // Uncomment when backend is ready
      return authCall<IPropertyList>({
        url,
        method: 'get',
      });
    });
  },

  useGetPropertyOwner: (propertyId: string) => {
    const url = propertyOwner(propertyId);
    return useSWR(url, async () => {
      return authCall<any>({
        url,
        method: 'get',
      });
    });
  },


  useGetPropertyTenants: (propertyId?: string) => {
    const url = propertyId ? propertyTenants(propertyId) : null;
    return useSWR(url, async () => {
      return authCall<any>({
        url: url!, // safe because url is only set if propertyId exists
        method: 'get',
      });
    });
  },
  
 approveProperty: async (propertyId: string, payload: PropertyApprovalPayload) => {
  const url = propertyApproval(propertyId)

  return authCall<PropertyApprovalResponse>({
    url,
    method: 'patch',
    data: payload,
  })
},


};

export default PropertyService;
